<template>
  <div class="dvBgiBox">
    <p style="font-size: 22px;font-weight: 600;text-align: center;">{{ $t('threePhase.powerStats') }}</p>

    <div style="width: 100%;height: 100%;">
      <Echart ref="bottomLeftChart" :options="chartData" id="bottomLeftChart" height="100%" width="100%"></Echart>
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'

export default {
  data() {
    return {
      chartData: {}
    };
  },
  props: {
    photovoltaicType: {
      default: 1
    },
    cdata: {},
  },
  components: {
    Echart
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  watch: {
    locale: {
      handler() {
        this.updateChartOptions();
      },
      immediate: true
    }
  },
  mounted() {
    this.updateChartOptions();
  },
  methods: {
    updateChartOptions() {
      this.chartData = {
        xAxis: {
          type: 'category',
          data: this.$t('threePhase.months'),
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisLabel: {
            color: '#fff',
            fontSize: 14,
            interval: 0,
            rotate: 45
          }
        },
        yAxis: {
          type: 'value',
          name: this.$t('threePhase.energyConsumption') + ' (kWh)',
          nameTextStyle: {
            color: '#fff',
            fontSize: 16,
            padding: [0, 0, 0, 10]
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            lineStyle: {
              color: '#fff',
              type: 'dashed'
            }
          },
          axisLabel: {
            color: '#fff',
            fontSize: 14,
            formatter: '{value} kWh'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            return params[0].name + '<br/>' +
              params[0].marker + params[0].seriesName + ': ' +
              params[0].value + ' kWh';
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '8%',
          containLabel: true
        },
        series: [{
          name: this.$t('threePhase.consumption'),
          data: [120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70],
          type: 'bar',
          itemStyle: {
            color: '#04e4c9',
            borderRadius: [6, 6, 0, 0],
            borderWidth: 0
          },
          label: {
            show: true,
            position: 'top',
            color: '#fff',
            fontSize: 14,
            fontWeight: '600',
            formatter: '{c} kWh'
          },
          barWidth: '50%',
          emphasis: {
            itemStyle: {
              color: '#03c6a9',
              shadowBlur: 10,
              shadowColor: 'rgba(4, 228, 201, 0.5)'
            }
          }
        }]
      };
    }
  }
}
</script>

<style scoped>
.dvBgiBox {
  width: 100%;
  height: 100%;
  /* background-image: url("../../assets/dvBgiBoxCenter.png"); */
  /* background-size: 100% 100%; */
  padding: 20px;
}
</style>